import React, { useEffect, useRef } from "react";

import "react-multi-carousel/lib/styles.css";

import { v4 as uuidv4 } from "uuid";

import sai from "../../assets/project/sai.png";
import school from "../../assets/project/school.png";
import dil_ki_bol from "../../assets/project/dil_ki_bol.png";
import redbricks from "../../assets/project/redbricks.png";
import uday_parker from "../../assets/project/uday_parker.png";
import bounz from "../../assets/project/bounz.png";
// import paper_recycle from "../../assets/project/paper_recycle.png";
// import knowledge_root from "../../assets/project/knowledge_root.png";
import finehh from "../../assets/project/finehh.png";
import motive from "../../assets/project/motive_supp.png";
import arabys from "../../assets/project/arabys.png";
import alnuaim from "../../assets/project/alnuaim.png";
import vms from "../../assets/project/VMS.png";
import shivSahyadri from "../../assets/project/shivSahyadri.png";
import npcop from "../../assets/project/npcop.jpg";
import { register } from "swiper/element/bundle";

const Projects = () => {
  const swiperRef = useRef(null);

  useEffect(() => {
    register();

    const params = {
      slidesPerView: 4,
      navigation: true,
      virtual: {
        enabled: true,
      },
      effect: "coverflow",
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
        320: {
          slidesPerView: 1
        },
        420: {
          slidesPerView: 1
        }
      },
    };

    Object.assign(swiperRef.current, params);

    swiperRef.current.initialize();
  }, []);
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const project_responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  let featureList = [
    // {
    //   id: uuidv4(),
    //   title: "Knowledge Root",
    //   image: knowledge_root,
    //   url: "https://knowledge-root.com/",
    // },
    // {
    //   id: uuidv4(),
    //   title: "Paper Recycking Confex",
    //   image: paper_recycle,
    //   url: "https://prcmea-dev.web.app/",
    // },
    // {
    //   id: uuidv4(),
    //   title: "Motiva Supplements",
    //   image: motive,
    //   url: "https://motivasupplements.com/",
    // },
    {
      id: uuidv4(),
      title: "Al-Nuaim",
      image: alnuaim,
      url: "https://play.google.com/store/apps/details?id=com.alnuiam",
    },
    {
      id: uuidv4(),
      title: "Vikrant Patil Office",
      image: vms,
      // url: "https://prcmea-dev.web.app/",
    },
    {
      id: uuidv4(),
      title: "श्री शिवसह्याद्री संस्था",
      image: shivSahyadri,
      url: "https://shreeshivsahyadrisanstha.in/",
    },
    // {
    //   id: uuidv4(),
    //   title: "Arabyads",
    //   image: arabys,
    //   url: "https://www.arabyads.com/",
    // },
    // {
    //   id: uuidv4(),
    //   title: "Fine Hygienic Holding",
    //   image: finehh,
    //   url: "https://finehh.com/",
    // },

    // {
    //   id: uuidv4(),
    //   title: "Dil Ki Bol",
    //   image: dil_ki_bol,
    //   url: "https://dilkiboli.com/publication/",
    // },
    // {
    //   id: uuidv4(),
    //   title: "Bounz",
    //   image: bounz,
    //   url: "https://millionaire.bounzrewards.com/",
    // },
    // {
    //   id: uuidv4(),
    //   title: "RedBrick",
    //   image: redbricks,
    //   url: "https://www.redbrickoffices.com/",
    // },
    // {
    //   id: uuidv4(),
    //   title: "Uday Parker",
    //   image: uday_parker,
    //   url: "https://udayparkar.com/",
    // },
    {
      id: uuidv4(),
      title: "Sais Sanstha",
      image: sai,
      url: "https://www.saisanstha.com/",
    },
    {
      id: uuidv4(),
      title: "E.B.GADKARI HOMOEOPATHIC MEDICAL COLLEGE & HOSPITAL",
      image: school,
      url: "https://www.ebghmc.org",
    },
    {
      id: uuidv4(),
      title: "Narasu Patil College of Physiotherapy",
      image: npcop,
      url: "https://npcop.org/",
    },
  ];

  return (
    <div className="mt-10" id="reviews">
      <p className="text-center text-[#333e49] text-2xl sm:text-4xl poppins-semibold">
        Our Works
      </p>
      <div className="px-5 sm:px-20 mt-5 sm:mt-10">
        <swiper-container init="false" ref={swiperRef}>
          {featureList.map((item) => (
            <swiper-slide  key={item.id}>
              <a href={item.url} target="_blank">
                <div className="relative w-full overflow-hidden h-80 rounded-3xl cursor-pointer text-2xl font-bold bg-purple-400">
                  <div className="z-10 absolute w-full h-full peer"></div>
                  <div className="absolute peer-hover:-top-20 peer-hover:-left-16 peer-hover:w-[140%] peer-hover:h-[140%] -top-32 -left-16 w-32 h-44 rounded-full bg-purple-300 transition-all duration-500"></div>
                  <div className="absolute flex text-xl text-center items-end justify-end peer-hover:right-0 peer-hover:rounded-b-none peer-hover:bottom-0 peer-hover:items-center peer-hover:justify-center peer-hover:w-full peer-hover:h-full -bottom-32 -right-16 w-36 h-44 rounded-full bg-purple-300 transition-all duration-500">
                    <span
                      className="poppins-semibold"
                    >
                      {item.title}
                    </span>
                  </div>
                  <div className="w-full h-full items-center justify-center flex uppercase">
                    <img
                      className="w-full h-full object-contain"
                      src={item.image}
                    />
                  </div>
                </div>
              </a>
            </swiper-slide>
          ))}
        </swiper-container>
      </div>
    </div>
  );
};

export default Projects;
